import type { Observable } from 'rxjs';

export abstract class BdExportAsFileAsyncData {
  /**
   * Starts the export and reports its outcome.
   *
   * Implementations MUST return a **one-shot** observable: emit a single
   * result and complete. Piping a non-completing source (a `Subject` /
   * `BehaviorSubject` such as a filter stream) keeps the dialog's
   * subscription alive after the export finished, so every later emission
   * re-POSTs the export — see BDA-6060. Snapshot such state with `take(1)`.
   */
  public abstract trigger(
    filename: string,
    labels?: string[],
    exportTemplate?: {
      exportTemplateId?: string;
      exportProperties?: string[];
    },
    /** Format chosen in the dialog's "Typ" picker; `undefined` when the export offers a single format. */
    exportType?: 'csv' | 'xlsx',
  ): Observable<{
    status: 'error' | 'ok';
    errors?: string[];
  }>;
}
